import { useEffect, useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname } = useLocation()

  // Prevent browser from restoring previous scroll position on navigation
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      const prev = window.history.scrollRestoration
      window.history.scrollRestoration = 'manual'
      return () => { window.history.scrollRestoration = prev }
    }
  }, [])

  // Synchronous after-DOM update scroll to top to avoid flicker
  useLayoutEffect(() => {
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    window.scrollTo(0, 0)
  }, [pathname])

  // Follow-up effect to ensure stubborn mobile browsers also scroll to 0
  useEffect(() => {
    // Check if mobile device
    const isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768
    
    const scrollToTop = () => {
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      window.scrollTo(0, 0)
      try { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }) } catch { }
    }
    
    // Immediate scroll
    scrollToTop()
    
    // Multiple attempts for mobile devices
    const timeouts = []
    if (isMobile) {
      timeouts.push(setTimeout(scrollToTop, 0))
      timeouts.push(setTimeout(scrollToTop, 10))
      timeouts.push(setTimeout(scrollToTop, 50))
      timeouts.push(setTimeout(scrollToTop, 100))
      timeouts.push(setTimeout(scrollToTop, 200))
    } else {
      timeouts.push(setTimeout(scrollToTop, 0))
    }
    
    // Use requestAnimationFrame for smoother scrolling
    requestAnimationFrame(() => {
      scrollToTop()
      requestAnimationFrame(scrollToTop)
    })
    
    return () => timeouts.forEach(t => clearTimeout(t))
  }, [pathname])

  return null
}
